module.exports = __webpack_public_path__ + "img/fire40.9deffd19.gif";